import React from "react";
import BlockLayout from "./../Layout/BlockLayout";
import ComponentHeader from "../Header/ComponentHeader";
import { primaryColor, secondaryColor } from "../../Util/Colors";
import { useInView } from "react-intersection-observer";
import styled from "styled-components";
import { device } from "../../Util/Breakpoints";
import {
  periodToComma,
  isCurrentYear,
  formatNumber
} from "../../Helpers/CommonHelper";
import SvgLayout from "./../Layout/SvgLayout";
import EmptySpace from "../Elements/EmptySpace";
import {
  headingLarge,
  FiguresWrapper,
  HeadingMunicipality
} from "../../Util/StyleProps";

const AnimatedDiv = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #0f0865;
  transform: scale(${props => (props.inView ? 1 : 0.8)});
  transition: transform 2.0s cubic-bezier(0.175, 0.885, 0.275, 1.235);
  border-radius: 1000px;
  padding: 24px 40px;
  text-align: center;
  font-family: 'Inter';
  font-weight: 700;
  width: fit-content;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.6px;
  
  @media${device.tablet} {
    font-size: 48px;
    line-height: 54px;
    letter-spacing: -0.7px;
  }

  @media${device.laptop} {
      font-size: 64px;
      line-height: 70px;
      letter-spacing: -0.9px;
      padding: 32px 48px;
  }
  .label{
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.15px;
    white-space: nowrap;
  }
`;

const TaxRateContainer = props => {
  const { data, sweden, blockColor, scroll } = props;

  let municipality1 = data[0];
  let municipality2 = data[1];

  let swedenTaxRate = sweden ? sweden.taxrate.taxRate : "(data saknas)";
  let swedenString = ` I Sverige betalar vi i genomsnitt ${periodToComma(
    swedenTaxRate.toFixed(2)
  )} procent i kommunal skatt (${
    sweden ? sweden.taxrate.year : "årtal saknas"
  }).`;

  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true
  });

  // Accessibility
  const ariaLabel = municipality => {
    const str = municipality
      ? isCurrentYear(municipality.year)
        ? "betalas"
        : "betalades"
      : "";

    return municipality
      ? `I ${
          municipality.name
        } kommun så ${str} det i genomsnitt ${municipality.taxRate.toFixed(
          2
        )} procent i kommunal skatt (${
          municipality.year ? "år " + municipality.year : "årtal saknas"
        })`
      : "";
  };

  return (
    <React.Fragment>
      <BlockLayout background={blockColor}>
        <svg style={{ marginBottom: "32px" }} xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67" fill="none">
        <path d="M33.3333 66.6667C28.7222 66.6667 24.3889 65.7917 20.3333 64.0417C16.2778 62.2917 12.75 59.9167 9.75 56.9167C6.75 53.9167 4.375 50.3889 2.625 46.3333C0.875 42.2778 0 37.9445 0 33.3333C0 28.7222 0.875 24.3889 2.625 20.3333C4.375 16.2778 6.75 12.75 9.75 9.75C12.75 6.75 16.2778 4.375 20.3333 2.625C24.3889 0.875 28.7222 0 33.3333 0C37.9445 0 42.2778 0.875 46.3333 2.625C50.3889 4.375 53.9167 6.75 56.9167 9.75C59.9167 12.75 62.2917 16.2778 64.0417 20.3333C65.7917 24.3889 66.6667 28.7222 66.6667 33.3333C66.6667 37.9445 65.7917 42.2778 64.0417 46.3333C62.2917 50.3889 59.9167 53.9167 56.9167 56.9167C53.9167 59.9167 50.3889 62.2917 46.3333 64.0417C42.2778 65.7917 37.9445 66.6667 33.3333 66.6667ZM33.3333 61.6667C37.1111 61.6667 40.7394 60.9497 44.2183 59.5158C47.6972 58.0825 50.7633 56.0217 53.4167 53.3333L33.3333 33.3333V5C25.4444 5 18.75 7.74472 13.25 13.2342C7.75 18.7236 5 25.4233 5 33.3333C5 41.2428 7.74472 47.9425 13.2342 53.4325C18.7242 58.922 25.4239 61.6667 33.3333 61.6667Z" fill="#1F44FF"/>
        </svg>
        <ComponentHeader
          heading={"Detta betalar vi i skatt"}
          text={swedenString}
        />
        {municipality1 ? (
          <div ref={ref}>
            <FiguresWrapper maxWidth="900px">
              {municipality1 ? (
                <SvgLayout width="47%">
                  <HeadingMunicipality
                    aria-label={ariaLabel(municipality1)}
                    marginBottom="24px"
                  >
                    {municipality1.name}
                  </HeadingMunicipality>
                  <AnimatedDiv
                    inView={inView}
                   >
                    <div>{periodToComma(municipality1.taxRate.toFixed(2))}</div>
                    <div className="label">procent</div>
                  </AnimatedDiv>
                </SvgLayout>
              ) : (
                <div></div>
              )}
              {municipality2 ? (
                <SvgLayout width="47%">
                  <HeadingMunicipality
                    color={secondaryColor}
                    aria-label={ariaLabel(municipality2)}
                    marginBottom="24px"
                  >
                    {municipality2.name}
                  </HeadingMunicipality>
                  <AnimatedDiv
                    inView={inView}
                    style={{
                      color: secondaryColor,
                     }}
                  >
                    <div>{periodToComma(municipality2.taxRate.toFixed(2))}</div>
                    <div className="label">procent</div>
                  </AnimatedDiv>
                </SvgLayout>
              ) : (
                <SvgLayout width="50%">
                  <EmptySpace scroll={scroll} />
                </SvgLayout>
              )}
            </FiguresWrapper>
          </div>
        ) : null}
      </BlockLayout>
    </React.Fragment>
  );
};

export default TaxRateContainer;
